module.exports = __webpack_public_path__ + "img/img24.04564f8a.png";